export interface DataProduct {
  title: string;
  description: string;
  url: string;
  icon?: string;
}

export const DATA_PRODUCTS: DataProduct[] = [
  {
    title: "Data Leap",
    description: "Discover Data",
    url: "https://ofdldataleap-harmony.harmony.a2z.com/",
    icon: "search"
  },
  {
    title: "FRI",
    description: "Reporting and Insights",
    url: "https://fri.finergy.amazon.dev/wwasf_decks/#!/",
    icon: "filter"
  },
  {
    title: "Fortune Reporting",
    description: "Get P&Ls",
    url: "https://reporting.allocations.finergy.amazon.dev/",
    icon: "key"
  },
  {
    title: "SliceIT",
    description: "Slice Data",
    url: "https://sliceit.corp.amazon.com/",
    icon: "treeview-expand"
  },
];
